<div class="container pt-2">
  <nav aria-label="breadcrumb" *ngIf="notLastBreadcrumbs.length > 0">
    <ol class="breadcrumb">
      <li class="breadcrumb-item" *ngFor="let crumb of notLastBreadcrumbs"><a [href]="crumb.url">{{crumb.label}}</a>
      </li>
      <li class="breadcrumb-item active" aria-current="page">{{lastBreadcrumb?.label}}</li>
    </ol>
  </nav>
</div>